import React from "react";
import OrgIcon from "../../../icons/OverviewOrgIcon.svg";
import ThemeIcon from "../../../icons/OverviewThemeIcon.svg";
import AuditsIcon from "../../../icons/OverviewAuditsIcon.svg";
import ComplaintIcon from "../../../icons/OverviewCompliantIcon.svg";
import NonComplaintIcon from "../../../icons/OverviewNonComplaintIcon.svg";
import styles from "./styles.module.scss";

const FilterLegend: React.FC = () => {
    return (
        <div className={styles.container}>
            <div className={styles.list}>
                <div className={styles.row}>
                    <div className={`${styles.iconWrapper} ${styles.organization}`}>
                        <img src={OrgIcon} alt="Organization" />
                    </div>
                    <span>Organization</span>
                </div>

                <div className={styles.row}>
                    <div className={`${styles.iconWrapper} ${styles.theme}`}>
                        <img src={ThemeIcon} alt="Theme" />
                    </div>
                    <span>Theme</span>
                </div>

                <div className={styles.row}>
                    <div className={`${styles.iconWrapper} ${styles.year}`}>
                        <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g clip-path="url(#clip0_969_1181)">
                                <path d="M4 1V3" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M8 1V3" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M9.5 2H2.5C1.94772 2 1.5 2.44772 1.5 3V10C1.5 10.5523 1.94772 11 2.5 11H9.5C10.0523 11 10.5 10.5523 10.5 10V3C10.5 2.44772 10.0523 2 9.5 2Z" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M1.5 5H10.5" stroke="white" stroke-width="1.25" stroke-linecap="round" stroke-linejoin="round" />
                            </g>
                            <defs>
                                <clipPath id="clip0_969_1181">
                                    <rect width="12" height="12" fill="white" />
                                </clipPath>
                            </defs>
                        </svg>

                    </div>
                    <span>Year</span>
                </div>

                <div className={styles.row}>
                    <div className={`${styles.iconWrapper} ${styles.audit}`}>
                        <img src={AuditsIcon} alt="Audit" />
                    </div>
                    <span>Audit</span>
                </div>

                <div className={styles.row}>
                    <div className={`${styles.iconWrapper} ${styles.compliant}`}>
                        <img src={ComplaintIcon} alt="Compliant" />
                    </div>
                    <span>Compliant</span>
                </div>

                <div className={styles.row}>
                    <div className={`${styles.iconWrapper} ${styles.nonCompliant}`}>
                        <img src={NonComplaintIcon} alt="Non-Compliant" />
                    </div>
                    <span>Non-Compliant</span>
                </div>
            </div>
        </div>
    );
};

export default FilterLegend;
